<template>
  <!-- Represents data from incoming_transactions from the server DB -->
  <div>
    <Navigation />
    
      <div v-if="downloadActivity" class="popUp-overlay"></div>
    <div class="row tableUsers">
       <div v-show="downloadActivity" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages">
              <div class="controls">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group has-error has-danger">
                      <label class="floatLeft" for="userData"
                        >Export Input Transactions (latest 10000 records)</label
                      >
                    </div>
                  </div>
                </div>
                <div class="row floatLeft">
                  <div class="col-md-12">
                    <v-btn
                      v-on:click="ExportResults();"
                      class="btn darkGreen btn-success poiner"
                      value="Download"
                    >Download</v-btn>
                    <v-btn 
                    class="btn btn-secondary pointer" 
                    v-on:click="cancelDownload()" 
                    >Cancel</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-show="deleteTransaction" class="popUp">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name"
                      >Are you sure you want to delete this Transaction?</label
                    >
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    v-on:click="deleteTransaction = false"
                    type="submit"
                    class="btn danger btnDark btn-success btn-send pointer"
                    value="Yes"
                  />
                  <input
                    v-on:click="deleteTransaction = false"
                    type="cancel"
                    class="btn btnDark btn-success pointer"
                    value="No"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-4 tableName2 mt-4">
                  <h2>Input Transactions</h2>
                </div>
                <div class="col-sm-12 col-md-5">
                  <!--Date from starts here-->
                  <v-app class="height-ovveride">
                    <v-row class="justify-content-around remove-scroll">
                      <v-col
                        cols="12"
                        sm="12"
                        md="6"
                        lg="4"
                        class="remove-scroll"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-left="660"
                          :nudge-top="30"
                          transition="scale-transition"
                          min-width="250px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="dateFrom"
                              label="Date from"
                              prepend-icon="event"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              color="rgba(18, 112, 92,1)"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateFrom"
                            @input="menu = false"
                            color="rgba(18, 112, 92,1)"
                            v-on:change="filterResults()"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>

                      <!--Date to starts here -->
                      <v-col
                        cols="12"
                        sm="12"
                        md="6"
                        lg="4"
                        class="remove-scroll"
                      >
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-left="660"
                          :nudge-top="30"
                          transition="scale-transition"
                          min-width="250px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="dateTo"
                              label="Date to"
                              prepend-icon="event"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              color="rgba(18, 112, 92,1)"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateTo"
                            @input="menu1 = false"
                            color="rgba(18, 112, 92,1)"
                            v-on:change="filterResults()"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-app>
                </div>
                <!-- Search starts here -->
                <div class="col-sm-12 col-md-3 mt-4">
                  <div id="datatable_filter" class="dataTables_filter">
                    <form
                      class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-2"
                    >
                      <input
                        v-model="search"
                        name="query"
                        v-on:keyup="filterResults()"
                        class="form-control borderNone form-control-sm mr-3"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i
                        class="fas fa-search"
                        aria-hidden="true"
                        v-on:click="filterResults()"
                      ></i>
                    </form>
                  </div>
                </div>
              </div>
              <!-- Search ends here -->
              <div class="row">
                <div class="col-sm-12 col-md-2 mt-1 text-left pl-4 heading">
                  Filter by brand:
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control form-control-sm"
                    id="brandsDropdownFilter"
                    @change="getAllPackageBrandOptions"
                    v-model="selectedBrandOptionId"
                    required
                  >
                    <option
                      v-bind:key="index"
                      v-for="(option, index) in allBrands"
                      v-bind:value="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control form-control-sm"
                    id="brandsDropdownFilter"
                    v-model="selectedPackageBrandOptionId"
                    @change="filterByPackageId"
                    required
                  >
                    <option
                      v-bind:key="index"
                      v-for="(option, index) in allPackageBrands"
                      v-bind:value="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>
                <div class="row">
                <div class="col-sm-12 col-md-2 mt-1 text-left pl-4 heading">
                  Filter by machine:
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control form-control-sm"
                    id="machineFilter"
                    @change="filterByMachineId"
                    v-model="selectedMachineId"
                    required
                  >
                    <option
                      v-bind:key="index"
                      v-for="(option, index) in allMachines"
                      v-bind:value="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-12 col-md-8 mt-1 text-right heading clearFilter" type="reset">
                    <button  @click="ClearFilters()">Clear filters</button>
                </div>
               
              </div>
              <div class="row">
                <!-- Table starts here -->
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="table table-striped table-bordered dataTable dtr-inline"
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Position: activate to sort column ascending"
                          v-on:click="sortResults(2)"
                        >
                          Machine Name
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="User name: activate to sort column ascending"
                          v-on:click="sortResults(3)"
                        >
                          User
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="User emial: activate to sort column ascending"
                          v-on:click="sortResults(3)"
                        >
                          User email
                        </th>
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Brand: activate to sort column descending"
                          v-on:click="sortResults(5)"
                        >
                          Brand
                          <!--TODO needs to add a btn in here to be sortable-->
                        </th>
                        
                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                          v-on:click="sortResults(4)"
                        >
                          Points
                        </th>

                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 100px"
                          aria-label=""
                        >
                          Containers
                        </th>
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortResults(1)"
                        >
                          Date
                          <!--TODO needs to add a btn in here to be sortable-->
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-bind:key="index"
                        v-for="(transaction, index) in transactions"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td>{{ transaction.m_name }}</td>
                        <td class="userFilter" title="Double click to filter by user" @dblclick="filterByUser(transaction.user_id,$event)">{{ transaction.u_username }}</td>
                          <td class="userFilter" title="Double click to filter by user" @dblclick="filterByUser(transaction.user_id,$event)">{{ transaction.u_email }}</td>
                             
                          <td>{{ transaction.brand }}</td>
                      
                        <td>{{ transaction.t_points }}</td>
                
                        
                        <td>{{ transaction.containers }}</td>
                        <td tabindex="0" class="sorting_1">
                          {{ transaction.t_createdon }}
                        </td>
                      </tr>
                      <!-- IMPLEMENT MESSAGE that there is no data for the selected date -->
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Table ends here -->
              <!-- Pagination starts here -->
              <!-- <div class="row">
                                <div class="col-sm-12 col-md-5"></div>
                                <div class="col-sm-12 col-md-3">
                                    <div class="dataTables_paginate paging_full_numbers" id="datatable_paginate">
                                        <ul class="pagination">
                                            <li class="paginate_button page-item active">
                                                <a href="#" aria-controls="datatable" data-dt-idx="2" tabindex="0" class="page-link">1</a>
                                            </li>
                                            <li class="paginate_button page-item ">
                                                <a href="#" aria-controls="datatable" data-dt-idx="3" tabindex="0" class="page-link">2</a>
                                            </li>
                                            <li class="paginate_button page-item ">
                                                <a href="#" aria-controls="datatable" data-dt-idx="4" tabindex="0" class="page-link">3</a>
                                            </li>
                                            <li class="paginate_button page-item ">
                                                <a href="#" aria-controls="datatable" data-dt-idx="5" tabindex="0" class="page-link">4</a>
                                            </li>
                                            <li class="paginate_button page-item ">
                                                <a href="#" aria-controls="datatable" data-dt-idx="6" tabindex="0" class="page-link">5</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2"></div>
                                <div class="col-sm-12 col-md-2">
                                <div class="dataTables_length" id="datatable_length">
                                    <label>Show entries<select name="datatable_length" aria-controls="datatable" class="custom-select custom-select-sm form-control form-control-sm showRows">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="-1">All</option>
                                    </select></label>
                                </div>
                            </div>
              </div>-->
              <pagination
                :meta_data="meta_data"
                v-on:next="fetchResults"
                v-on:ExportResults="triggerDownload"
              ></pagination>
              <!-- pagination ends here -->
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  </div>
</template>

<script>
import Navigation from "@/views/Navigation.vue";
import Pagination from "@/components/Pagination.vue";
import axios from 'axios';
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      deleteTransaction: false,
      transactions: [],
      search: null,
      order: null,
      sort: null,
      dir: 0,
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
        exportData: true
      },
      dateFrom: null,
      dateTo: new Date().toISOString().substr(0, 10),
      menu: false,
      menu1: false,
      // new code goes here?
      allBrands: [],
      selectedBrandOptionId: null,
      allPackageBrands: [],
      selectedPackageBrandOptionId: null,
      selected_user_id: null,
      altUser: "Double click to filter by user",
      downloadActivity: false,
      // filterByMachineId: null,
      allMachines: [],
      selectedMachineId: null
      
    };
  },
  mounted() {
    this.fetchResults(
      this.meta_data.current_page,
      this.meta_data.perpage,
      this.search,
      this.dateFrom,
      this.dateTo,
      this.order,
      this.sort,
      this.meta_data.total,
      this.selected_user_id, 
      this.selectedBrandOptionId, 
      this.selectedPackageBrandOptionId,
      this.selectedMachineId
    );
    // transfered bot
    this.getAllBrandsOptions();
    this.getAllMachines();
  },
  methods: {
    cancelDownload(){
      this.downloadActivity = false;
    },
    del() {
      this.$data.deleteTransaction = true;
    },
    fetchResults(
      page = this.meta_data.current_page,
      perpage = this.meta_data.perpage,
      search = this.search,
      dateFrom = this.dateFrom,
      dateTo = this.dateTo,
      order = this.order,
      sort = this.sort,
      total = this.meta_data.total,
      user_id = this.selected_user_id,
      brand_id = this.selectedBrandOptionId,
      brand_package_id = this.selectedPackageBrandOptionId,
      machine_id =   this.selectedMachineId
    ) {
      axios
        .get(store.state.BASE_URI + "admin/transactions/load_transactions", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            dateFrom,
            dateTo,
            order,
            sort,
            total,
            user_id,
            brand_id,
            brand_package_id,
            machine_id
          },
        })
        .then((res) => {
          this.transactions = res.data.results.transactions;
          var pagination = res.data.results.pagination;

          this.meta_data.last_page = pagination.last_page;
          this.meta_data.current_page = pagination.current_page;
          this.meta_data.prev_page_url = pagination.prev_page_url;
          this.meta_data.perpage = pagination.perpage;
          this.meta_data.search = pagination.search;
          this.meta_data.total = pagination.total;
        })
        .catch((err) => console.log(err));
    },
    sortResults(order) {
      this.dir++;
      this.order = order;

      if (this.dir % 2 == 0) this.sort = "desc";
      else this.sort = "asc";
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.dateFrom,
        this.dateTo,
        this.order,
        this.sort,
        this.total, 
        this.selected_user_id,
        this.selectedBrandOptionId,
        this.selectedPackageBrandOptionId,
        this.selectedMachineId
      );
    },
    filterResults() {
      this.meta_data.current_page = 1;
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.dateFrom,
        this.dateTo,
        this.order,
        this.sort,
        this.total,
        this.selected_user_id,
        this.selectedBrandOptionId,
        this.selectedPackageBrandOptionId,
        this.selectedMachineId
      );
      //  console.log(
      //    "fired ->" + this.search + " " + this.dateFrom + " " + this.dateTo
      //  );
    },
    // transfered to bottom(Stays here only for test)
    getAllPackageBrandOptions() {
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("accessToken");
      axios
        .get(
          store.state.BASE_URI +
            "admin/packaging/select_packaging_by_brand?brand_id=" +
            this.selectedBrandOptionId
          //  { params: { brand_id: this.selectedBrandOptionId } }
        )
        .then((response) => {
          this.allPackageBrands = response.data.results;
        this.filterResults();
        })
        .catch((error) => {
          console.log(error);
          // TODO PUSH NOTIFICATION ERROR
        });
    },
    getAllBrandsOptions() {
      console.log("ovde treba povik");
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("accessToken");
      axios
        .get(store.state.BASE_URI + "admin/brands/all_brands")
        .then((response) => {
          console.log("all brands se", response);
          this.allBrands = response.data.brands;
        })
        .catch((error) => {
          console.log("eroro e", error);
          // TODO PUSH NOTIFICATION ERROR
        });
    },
     getAllMachines() {
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("accessToken");
      axios
        .get(store.state.BASE_URI + "admin/machines/load_all_machines")
        .then((response) => {
          console.log("all machines se", response);
          this.allMachines = response.data.results;
        })
        .catch((error) => {
          console.log("eroro e", error);
          // TODO PUSH NOTIFICATION ERROR
        });
    },
    filterByUser(user_id){
       this.selected_user_id = user_id;
      
       this.filterResults();
    },
    filterByPackageId(){
      
       this.filterResults();
    },
    filterByMachineId(){
     
      this.filterResults();
    },
    triggerDownload(){
      this.downloadActivity = true;
      console.log(this.downloadActivity)
    },
   ExportResults(
       page = 1,
       perpage = 10000,
        search = this.search,
        dateFrom = this.dateFrom,
        dateTo = this.dateTo,
        order = this.order,
        sort = this.sort,
        total = this.meta_data.total,
        user_id = this.selected_user_id,
        brand_id = this.selectedBrandOptionId,
        brand_package_id = this.selectedPackageBrandOptionId,
        machine_id =  this.selectedMachineId
      
    ) {
      axios
        .get(store.state.BASE_URI + "admin/transactions/load_transactions", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            dateFrom,
            dateTo,
            order,
            sort,
            total,
            user_id,
            brand_id,
            brand_package_id,
            machine_id
          },
        })
        .then((res) => {
            getReport(res.data.results.transactions);
            this.downloadActivity = false;
        })
        .catch((err) => console.log(err));
    },
   ClearFilters() {
      this.meta_data.current_page = 1,
      this.meta_data.perpage = 5,
      this.search = null,
      this.order =null,
      this.sort = null,
      this.dateFrom = null,
      this.dateTo = new Date().toISOString().substr(0, 10),
      this.total = 0,
      this.selected_user_id = null,
      this.selectedBrandOptionId = null,
      this.selectedPackageBrandOptionId = null,
      this.selectedMachineId = null,
       this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.dateFrom,
        this.dateTo,
        this.order,
        this.sort,
        this.total,
        this.selected_user_id,
        this.selectedBrandOptionId,
        this.selectedPackageBrandOptionId,
        this.selectedMachineId
    );
   
    },
   },
  computed: {
    //    users() {
    //      return this.$store.getters.getUsers;
    //    },
  },
  created() {
    //    this.$store.dispatch("fetchUsers")
  },
};
const objectToCsv = function(data) {
  //  console.log(data);
  const csvRows = [];

  //  // add headers
  const headers = ["Machine Name", "User Name", "User Email", "Brand",  "Points", "Date"];
  csvRows.push(headers.join(','));

  //  // add statistics

  for (const row of data) {

        const values2 = [
          row.m_name,
          row.u_username,
          row.u_email,
          row.brand,
          row.t_points,
          row.t_createdon,
        ];
        csvRows.push(values2.join(','));
  }

  csvRows.push(["\n"].join(','));


  return csvRows.join("\n");
};
const download = function(data, fileName) {
  const BOM = "\uFEFF";
  const csvData = BOM + data;
  const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" }); 
  //  const blob = new Blob([data], { type: "text/csv;charset=utf-8"});
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", fileName + ".csv");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
const getReport = async function(reportInfo) {
  const res = reportInfo;
  const csvData = objectToCsv(res);
  const today = new Date().toISOString().slice(0, 10);
  //  console.log(csvData);
  download(csvData, 'recycling_report_'+today);
};
</script>

<style src="../css/style.css"></style>
